// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { multipart, post, put } from '../../../../common/api'
import { ADD_PROJECT, ADD_PROJECT_MODULE, COMPLETED_PROJECT_MODULE, DELETE_PROJECT, DELETE_PROJECT_MODULE, EDIT_PROJECT, EDIT_PROJECT_MODULE, GET_PROJECT, GET_PROJECT_MODULE, PROJECT, PROJECT_MODULE } from '../../../../common/constant'

export const actionProject = createAsyncThunk('appProject/actionProject', async (params, thunkAPI) => {
    return await post(PROJECT, params, thunkAPI)
})

export const actionAddProject = createAsyncThunk('appProject/actionAddProject', async (params, thunkAPI) => {
    return await put(ADD_PROJECT, params, thunkAPI)
})

export const actionGetProject = createAsyncThunk('appProject/actionGetProject', async (params, thunkAPI) => {
    return await post(GET_PROJECT, params, thunkAPI)
})

export const actionEditProject = createAsyncThunk('appProject/actionEditProject', async (params, thunkAPI) => {
    return await post(EDIT_PROJECT, params, thunkAPI)
})

export const actionAddProjectModule = createAsyncThunk('appProject/actionAddProjectModule', async (params, thunkAPI) => {
    return await multipart(ADD_PROJECT_MODULE, params, thunkAPI)
})

export const actionGetProjectModule = createAsyncThunk('appProject/actionGetProjectModule', async (params, thunkAPI) => {
    return await post(GET_PROJECT_MODULE, params, thunkAPI)
})

export const actionEditProjectModule = createAsyncThunk('appProject/actionEditProjectModule', async (params, thunkAPI) => {
    return await post(EDIT_PROJECT_MODULE, params, thunkAPI)
})

export const actionProjectModule = createAsyncThunk('appProject/actionProjectModule', async (params, thunkAPI) => {
    return await post(PROJECT_MODULE, params, thunkAPI)
})

export const actionDeleteProject = createAsyncThunk('appProject/actionDeleteProject', async (params, thunkAPI) => {
    return await post(DELETE_PROJECT, params, thunkAPI)
})

export const actionDeleteProjectModule = createAsyncThunk('appProject/actionDeleteProjectModule', async (params, thunkAPI) => {
    return await post(DELETE_PROJECT_MODULE, params, thunkAPI)
})

export const actionCompletedProjectModule = createAsyncThunk('appProject/actionCompletedProjectModule', async (params, thunkAPI) => {
    return await post(COMPLETED_PROJECT_MODULE, params, thunkAPI)
})

export const appProjectSlice = createSlice({
    name: 'appProject',
    initialState: {

        //list
        loading: false,
        project: null,

        //add
        loadingAdd: false,
        addProject: null,

        //get
        loadingGet: false,
        getProject: null,

        //edit
        loadingEdit: false,
        editProject: null,

        //delete
        loadingDelete: false,
        deleteProject: null,

        //projectModulelist
        loadingModules: false,
        projectModules: null,

        //addProjectModule
        loadingAddModule: false,
        addProjectModule: null,

        //getProjectModule
        loadingGetModule: false,
        getProjectModule: null,

        //editProjectModule
        loadingEditModule: false,
        editProjectModule: null,

        //deleteProjectModule
        loadingDelete: false,
        deleteProjectModule: null,

        //completedProjectModule
        loadingComplete: false,
        completeProjectModule: null
    },
    reducers: {

        resetProjectResponse: (state) => {
            state.project = null
        },
        resetAddProjectResponse: (state) => {
            state.addProject = null
        },
        resetGetProjectResponse: (state) => {
            state.getProject = null
        },
        resetEditProjectResponse: (state) => {
            state.editProject = null
        },
        resetProjectDeleteResponse: (state) => {
            state.deleteProject = null
        },
        resetProjectModuleResponse: (state) => {
            state.projectModules = null
        },
        resetAddProjectModuleResponse: (state) => {
            state.addProjectModule = null
        },
        resetGetProjectModuleResponse: (state) => {
            state.getProjectModule = null
        },
        resetEditProjectModuleResponse: (state) => {
            state.editProjectModule = null
        },
        resetProjectModuleDeleteResponse: (state) => {
            state.deleteProjectModule = null
        },
        resetProjectModuleCompleteResponse: (state) => {
            state.completeProjectModule = null
        }
    },
    extraReducers: builder => {
        builder

            //list
            .addCase(actionProject.pending, (state) => {
                state.loading = true
            })
            .addCase(actionProject.fulfilled, (state, action) => {
                state.loading = false
                state.project = action.payload
            })
            .addCase(actionProject.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddProject.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddProject.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addProject = action.payload
            })
            .addCase(actionAddProject.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetProject.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetProject.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getProject = action.payload
            })
            .addCase(actionGetProject.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditProject.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditProject.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editProject = action.payload
            })
            .addCase(actionEditProject.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteProject.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteProject.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteProject = action.payload
            })
            .addCase(actionDeleteProject.rejected, (state) => {
                state.loadingDelete = false
            })

            //listProjectModule
            .addCase(actionProjectModule.pending, (state) => {
                state.loadingModules = true
            })
            .addCase(actionProjectModule.fulfilled, (state, action) => {
                state.loadingModules = false
                state.projectModules = action.payload
            })
            .addCase(actionProjectModule.rejected, (state) => {
                state.loadingModules = false
            })

            //addProjectModule
            .addCase(actionAddProjectModule.pending, (state) => {
                state.loadingAddModule = true
            })
            .addCase(actionAddProjectModule.fulfilled, (state, action) => {
                state.loadingAddModule = false
                state.addProjectModule = action.payload
            })
            .addCase(actionAddProjectModule.rejected, (state) => {
                state.loadingAddModule = false
            })

            //editProjectModule
            .addCase(actionEditProjectModule.pending, (state) => {
                state.loadingEditModule = true
            })
            .addCase(actionEditProjectModule.fulfilled, (state, action) => {
                state.loadingEditModule = false
                state.editProjectModule = action.payload
            })
            .addCase(actionEditProjectModule.rejected, (state) => {
                state.loadingEditModule = false
            })

            //getProjectModule
            .addCase(actionGetProjectModule.pending, (state) => {
                state.loadingGetModule = true
            })
            .addCase(actionGetProjectModule.fulfilled, (state, action) => {
                state.loadingGetModule = false
                state.getProjectModule = action.payload
            })
            .addCase(actionGetProjectModule.rejected, (state) => {
                state.loadingGetModule = false
            })

            //deleteProjectModule
            .addCase(actionDeleteProjectModule.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteProjectModule.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteProjectModule = action.payload
            })
            .addCase(actionDeleteProjectModule.rejected, (state) => {
                state.loadingDelete = false
            })

            //completeProjectModule
            .addCase(actionCompletedProjectModule.pending, (state) => {
                state.loadingComplete = true
            })
            .addCase(actionCompletedProjectModule.fulfilled, (state, action) => {
                state.loadingComplete = false
                state.completeProjectModule = action.payload
            })
            .addCase(actionCompletedProjectModule.rejected, (state) => {
                state.loadingComplete = false
            })
    }
})
export const { resetAddProjectResponse, resetProjectResponse, resetEditProjectResponse, resetGetProjectResponse, resetAddProjectModuleResponse, resetProjectModuleResponse, resetGetProjectModuleResponse, resetEditProjectModuleResponse, resetProjectDeleteResponse, resetProjectModuleDeleteResponse, resetProjectModuleCompleteResponse } = appProjectSlice.actions

export default appProjectSlice.reducer